import { useIsDebug, useJeffect, useLogger } from "@kosmod/kit";
import { Component, h, useEffect, useRef } from "@lukekaalim/act";
import { TheatreState } from "../hooks/useTheatreState";
import { renderBeat } from "@kosmod/graphics-3d";

export type DebugReadoutProps = {
  state: TheatreState
}

export const DebugReadout: Component<DebugReadoutProps> = ({ state }) => {
  const IS_DEBUG = useIsDebug();

  const debugTextRef = useRef<null | HTMLElement>(null);

  const onRender = renderBeat.useBeat()

  useJeffect(j => {
    const debugText = debugTextRef.get();
    const camera = state.camera.get();
    if (!debugText || !camera)
      return;

    j.add(onRender(() => {
      const cursor = state.cursorPosition.get();

      debugText.innerText = [
        cursor ? `cursor(${cursor.vector.x.toFixed(3)}x, ${cursor.vector.y.toFixed(3)}y)` : `cursor(null)`,
        `camera_target(${camera.targetPosition.x.toFixed(3)}x, ${camera.targetPosition.z.toFixed(3)}z)`,
        `camera_rotation(${camera.rotation.toFixed(3)}pi)`,
        `camera_forward(${camera.forward.x.toFixed(3)}x, ${camera.forward.y.toFixed(3)}y)`,
        `selection(${JSON.stringify(state.selection.target)})` + (state.selection.hover.type !== 'none' ? ` + hover(${JSON.stringify(state.selection.hover)})` : ''),
        `tool(${JSON.stringify(state.tools.getActiveTool()?.state || 'none')})`,
      ].join('\n')
    }));

  }, [IS_DEBUG, state.selection, state.tools.activeTool])


  return [
    IS_DEBUG && [
      h('div', { ref: debugTextRef, style: { position: 'absolute', bottom: '5px', left: '5px', color: 'white', 'font-family': 'monospace' } }),
    ],
  ]
}